import styled from '@emotion/styled';
import { alpha } from '@mui/material/styles';

import { materialTheme } from '../../particles';

const StyledTable = styled.div<{ $headerHeight: number }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 16px;
  background: ${materialTheme.palette.background.paper};
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.08);
  min-width: 0;

  .pointer {
    cursor: pointer;
  }

  .table-toolbar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px 20px 12px;
    border-bottom: 1px solid rgba(15, 23, 42, 0.08);
    background: linear-gradient(
      180deg,
      rgba(248, 250, 252, 0.95) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  }

  .table-scroll-container {
    width: 100%;
    overflow-x: auto;
    border-radius: 0 0 16px 16px;
  }

  .table-scroll-container::-webkit-scrollbar {
    height: 10px;
  }

  .table-scroll-container::-webkit-scrollbar-track {
    background-color: rgba(15, 23, 42, 0.08);
    border-radius: 8px;
  }

  .table-scroll-container::-webkit-scrollbar-thumb {
    background-color: rgba(15, 23, 42, 0.35);
    border-radius: 8px;
    border: 2px solid rgba(255, 255, 255, 0.4);
  }

  table {
    border-collapse: separate;
    border-spacing: 0;
    width: max-content;
    min-width: 100%;
  }

  thead tr {
    background: linear-gradient(
      180deg,
      rgba(248, 250, 252, 1) 0%,
      rgba(237, 242, 247, 1) 100%
    );
  }

  thead th {
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    font-weight: 700;
    color: rgba(15, 23, 42, 0.65);
    padding: 14px 18px;
    border-bottom: 2px solid rgba(15, 23, 42, 0.12);
    white-space: nowrap;
    background: transparent;
  }

  tbody tr {
    transition: background-color 0.2s ease, transform 0.2s ease;
    border-bottom: 1px solid rgba(15, 23, 42, 0.06);

    &:hover {
      background-color: ${alpha(materialTheme.palette.primary.main, 0.04)};
      transform: translateY(-1px);
    }

    &:last-of-type {
      border-bottom: none;
    }
  }

  tbody td {
    font-size: 14px;
    color: rgba(15, 23, 42, 0.87);
    padding: 12px 18px;
    vertical-align: top;
    word-break: break-word;
    max-width: 360px;
    background-color: transparent;
  }

  .table-cards {
    border-radius: 16px;
    background: ${materialTheme.palette.background.paper};
    overflow: hidden;

    table {
      width: 100%;
      border-collapse: separate;
      border-spacing: ${materialTheme.spacing(0, 2)};
      padding: ${materialTheme.spacing(0, 1)};
    }

    th {
      border-bottom: unset;
    }

    td {
      border: 1px solid rgba(15, 23, 42, 0.1);
      border-radius: 12px;
      padding: 16px;

      :first-of-type {
        border-left-width: 1px;
      }

      :last-of-type {
        border-right-width: 1px;
      }
    }

    .header-background {
      background-color: ${materialTheme.palette.primary.light};
      position: relative;
      z-index: 3;
      ${({ $headerHeight }) => ($headerHeight ? `height: ${$headerHeight + 1}px;` : ``)}
      top: ${materialTheme.spacing(2)}px;
      border-bottom: 1px solid rgba(224, 224, 224, 1);
    }

    .table-cards-wrapper {
      display: block;
      z-index: 5;
      position: relative;
      ${({ $headerHeight }) => ($headerHeight ? `top: -${$headerHeight + 1}px;` : ``)}
    }
  }
`;

export default StyledTable;
